import { useEffect, useState } from "react";
import { api } from "../../helpers/apiCore";
import { endpoints } from "../../helpers/Endpoints";
import backBtn from "../../assets/icons/arrow_left.svg";
import { Button, Spinner } from "react-bootstrap";
import UpdateRole from "./UpdateRole";
import { IRole, Permission } from "../../types";

interface RoleDetailsProps {
	showModal: boolean;
	onHide: () => void;
	roleData: IRole;
	formatDate: (dateString: moment.MomentInput) => string;
}

const RoleDetails = ({ showModal, onHide, formatDate, roleData }: RoleDetailsProps) => {
	const [isLoading, setIsLoading] = useState(false);
	const [showAlert, setShowAlert] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const [showRoleDetails, setShowRoleDetails] = useState(true);
	const [showUpdateRole, setShowUpdateRole] = useState(false);

	// const fetchRoleDetails = async () => {
	// 	setIsLoading(true);
	// 	try {
	// 		api.setAuthorization(api.getLoggedInUser());
	// 		const response = await api.get(endpoints.getRole(initialRoleId), {});
	// 		setRoleData(response.data.data);
	// 		setIsLoading(false);
	// 	} catch (error) {
	// 		console.error("Error fetching role", error);
	// 		setIsLoading(false);
	// 	} finally {
	// 		setIsLoading(false);
	// 	}
	// };

	// useEffect(() => {
	// 	if (initialRoleId) {
	// 		fetchRoleDetails();
	// 	}
	// }, [initialRoleId]);

	

	const renderPermissions = (permissions: Permission[]) => {
		if (permissions && Array.isArray(permissions)) {
			return permissions.map((permission, index) => (
				<div key={index} className="permissions-data">
					{Object.entries(permission).map(([category, actions]) => (
						<div key={category}>
							<p className="mt-3 mb-0">{category}</p>
							{actions.map((action, actionIndex) => (
								<span key={actionIndex} className="action">{action}</span>
							))}
						</div>
					))}
				</div>
			));
		}
		return null;
	};

const closeUpdateRole = () => {
		setShowUpdateRole(false);
		onHide();
	};

	return (
		<>
			{showRoleDetails && (
				<>
					<div className="modal-backdrop" onClick={onHide}></div>
					<div className="modal-container">
						<div className="book-details-body">
							<div className="custom-modal-header">
								<div>
									<img src={backBtn} alt="back" onClick={onHide} style={{ cursor: 'pointer' }} />
									<h4>Role & Permission Detail</h4>
								</div>

								<Button onClick={() => { setShowRoleDetails(false); setShowUpdateRole(true); }}>Edit</Button>
							</div>
						</div>

						{isLoading ? (
							<div className="spinner-div">
								<Spinner animation="border" size="sm" role="status" />
							</div>
						) : (
							<div className="custom-modal-body">
								<div className="detail-section">
									<div className="book-detail">
										<span>Role Title</span>
										<p>{roleData?.name}</p>
									</div>

									{/* <div className="book-details">
										<span className="">Permissions</span>
										<p>{renderPermissions(roleData?.permissions)}</p>
									</div> */}
								</div>

								{/* <div className="detail-section">
									<div className="book-detail">
										<span>No. of Admins</span>
										<p>{roleData?.userCount}</p>
									</div>
								</div> */}

								<div className="detail-section">
									<div className="book-detail">
										<span>Date Created</span>
										<p>{formatDate(roleData?.created_at)}</p>
									</div>
								</div>
							</div>
						)}
					</div>
				</>
			)}

			{!showRoleDetails && showUpdateRole && (
				<UpdateRole
					roleId={roleData.id}
					onHide={closeUpdateRole}
				/>
			)}
		</>
	)
};

export default RoleDetails;